<div class="login row">
  <div class="BGLogin col">
    <img alt="Background Login" src="assets/svg/BG-Login.png" />
  </div>

  <div class="Login_BoxForm col-3">
    <div class="BoxForm_Content">
      <div class="BoxForm_Title">
        <img alt="Icon Login" src="assets/svg/icon_login.svg">
        <p data-e2e="first-acess-title">Concluir criação de acesso</p>
      </div>
      <div class="BoxForm_Form">
        <form class="form-login" [formGroup]="formFirstAccess" (ngSubmit)="onSubmit()">
          <div class="login-fa-cpf">
            <span data-e2e="fill-cpf-label" class="login-fa-cpf-resp">Preencha o CPF de <a href="#" target="_blank" rel="noopener noreferrer">cadastro</a>.</span>
          </div>
          <div class="input-group mb-3">
            <p class="Form_TitleInput">CPF</p>
            <div class="input-group-prepend Form_Prepend">
              <span class="input-group-text"><img alt="Icon Login User" src="assets/svg/icon_login_user.svg" class="IconInput"></span>
            </div>
            <input data-e2e="cpf-input" formControlName="documentNumber" type="text" class="form-control FormInput_Usuario" placeholder="" aria-label="Username"
              aria-describedby="basic-addon1">
          </div>
          @if (enableBtnEnviar) {
            <div style="width: 20rem;">
              <app-generic-button-v2 [buttonSettings]="{
            type: 'button',
            label: 'ENVIAR',
            dataE2e: 'cpf-submit-btn',
            idHtml: 'cpf-submit-btn',
            color: 'primary',
            enableBorder: true,
            responsive: true,
            }" (clickedEvent)="onSubmit()"/>
            </div>
          }
        </form>

        @if (enableBtnEnviar) {
          <div class="FormLogin_Divider">
            <p>OU</p>
          </div>
        }

        <div class="Login_ForgotPassword">
          <a data-e2e="back-to-login-btn" href="/login" class="Login_btn_ForgotPassword">
            Voltar
          </a>
        </div>

        <div class="BoxForm_LogoRepomResponsive">
          <img alt="Footer Logo Repom" src="assets/svg/footer_logo_repom.svg">
        </div>
      </div>
    </div>
    <!--BoxForm_Content-->
  </div>
  <!--Login_BoxForm-->
  <!-- **************** Login | End **************** -->
</div>

